module.exports = __webpack_public_path__ + "img/header-phone.317445e1.jpg";